import { apiContainer } from '@vlabs/api-bindings';
import i18n from 'i18next';
import { toast } from 'react-toastify';

import { confirmDeleteFaces } from './confirmDeleteFaces';

interface TDeleteFacesOptions {
  faceIds: string[];
}

export function deleteFaces({ faceIds }: TDeleteFacesOptions): void {
  const onConfirm = async (): Promise<void> => {
    try {
      await apiContainer.lunaClient.faces.deleteMany(faceIds);
      toast.success(i18n.t('monokit:delete faces.toast.success'));
    } catch {
      toast.error(i18n.t('monokit:delete faces.toast.error'));
    }
  };

  confirmDeleteFaces({ onConfirm });
}
